import { TemplatePage } from './types';

const travelVlogPage: TemplatePage = {
  header: {
    color: '#F4F4F4',
    icon: 'images/video-templates/travel-tourism.jpg',
    title: 'Travel Vlog Video Templates',
    title_meta: 'Free Travel Vlog Video Templates',
    description_meta:
      'Make amazing videos for your travel vlog with a collection of beautiful free video templates. Try now!',
    description:
      'Boost your travel vlog engagement and expand your audience through captivating videos. These free video templates ' +
      'are specifically designed to grip your audience’s attention. Replace the text, change the background video or image, and share the video on your vlog. You’ll see likes and shares come pouring in.'
  },
  footer: {
    category: 'Travel Vlog',
    description:
      'Video marketing is the best way to promote your travel vlog or business. Discover Wave.video’s collection of video ' +
      'templates that have been carefully crafted by experienced designers and tailored for maximum engagement.'
  },
  content: [
    {
      type: 'templates',
      title: 'Travel Vlog Videos',
      search: { name: 'travel vlog' }
    },
    {
      type: 'stocks',
      title: 'travel vlog',
      search: { category: 'travel vlog' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default travelVlogPage;
